import {UploadFile} from '@/components/molecules'
import {Constants} from '@/utils/constants/commonConstants'
import {useState} from 'react'
import {Toggle} from '@/components/atoms'

export const ImageOptimization = () => {
  const [images, setImages] = useState([])
  const [toggleValue, setToggleValue] = useState(false)

  const convertBlobToFile = (blob, fileName) => {
    return new File([blob], fileName, {
      type: blob.type,
      lastModified: Date.now(),
    })
  }

  const convertImageToWebP = async file => {
    const originalSize = file.size

    const webpBlob = await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = event => {
        const img = new Image()
        img.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          canvas.toBlob(
            blob => {
              if (blob) {
                resolve(blob)
              } else {
                reject(new Error('Conversion to WebP failed'))
              }
            },
            'image/webp',
            0.7
          )
        }
        img.src = event.target.result
      }
      reader.readAsDataURL(file)
    })

    const webpFile = convertBlobToFile(webpBlob, file.name)
    const webpUrl = URL.createObjectURL(webpBlob)
    const originalUrl = URL.createObjectURL(file)

    return {
      originalUrl,
      optimizedUrl: webpUrl,
      originalSize,
      optimizedSize: webpFile.size,
      fileName: file.name,
      dimensions: {width: '', height: ''},
    }
  }

  const handleFileChange = async e => {
    const files = Array.from(e.target.files)

    const convertedImages = await Promise.all(files.map(file => convertImageToWebP(file)))
    setImages(prev => [...prev, ...convertedImages])
  }

  const updateDimensions = (index, name, value) => {
    setImages(prev =>
      prev.map((img, idx) => (idx === index ? {...img, dimensions: {...img.dimensions, [name]: value}} : img))
    )
  }

  return (
    <div>
      <input type="file" onChange={handleFileChange} multiple />

      {images.map((img, idx) => (
        <div key={idx} className="mt-8 border p-4">
          <div className="flex justify-between">
            <div>
              <strong>Before</strong>
              <img src={img.originalUrl} alt="Original" className="mt-2 max-w-[200px]" />
              <div>Size: {img.originalSize} bytes</div>
            </div>
            <div>
              <strong>After</strong>
              <img
                src={img.optimizedUrl}
                alt="WebP"
                style={{
                  maxWidth: img.dimensions.width || '300px',
                  maxHeight: img.dimensions.height || '300px',
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  imageRendering: 'auto',
                }}
                className="mt-2"
              />
              <div>Size: {img.optimizedSize} bytes</div>
            </div>
          </div>

          <Toggle
            uiSchema={{isDark: true, label: 'Manual Dimensions?', size: 'small'}}
            updateValue={() => setToggleValue(!toggleValue)}
            value={toggleValue}
          />

          {toggleValue && (
            <div className="mt-4 flex gap-4">
              <input
                type="text"
                placeholder="Width"
                name="width"
                value={img.dimensions.width}
                onChange={e => updateDimensions(idx, 'width', e.target.value)}
                className="border p-1 text-black"
              />
              <input
                type="text"
                placeholder="Height"
                name="height"
                value={img.dimensions.height}
                onChange={e => updateDimensions(idx, 'height', e.target.value)}
                className="border p-1 text-black"
              />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default ImageOptimization
